import store from '@/store/index';
import { isProPlusContext } from '@/plans/ZOOM_MEETING/common/utils';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import MessageBox from '@zoom/zoom-ui/src/components/message-box/message-box';
import { translation } from '@/plugins/i18n';
import _ from 'lodash';
import { plansof } from '@/utils/chain';
import { computedCallingPlans, computedPbxAddonPlans } from '@/common/service/computers/plans/pbx';
import { getCommonContactSalesLink } from '@/utils/i18n-shortcuts';
import Vue from 'vue';

export const preCheckZoneProPlusForBuyNow = () => {
  const getters = store.getters;

  const currentBasePlanType = getters.getCurrentBasePlanInfo.planType;

  // config baseplan is zoom one pro plus
  if (isProPlusContext && currentBasePlanType === planTypes.ZONE_PRO_PLUS) {
    const callingPlanCount = plansof(getters.getSelectedPlans).type(planTypes.ZONE_PRO_PLUS).sum('license');
    const limitLicenseWithCurrentBaseTypes = getters.limitLicenseWithCurrentBaseTypes;

    const maxBaseLicensePlans = _.filter(getters.getUserCurrentSubscriptions, item => {
      return _.includes(limitLicenseWithCurrentBaseTypes, item.type) &&
        item.cartInfo.selected_number > callingPlanCount && item.billing_cycle !== BILLING_CYCLE.ONE_TIME;
    });

    if (maxBaseLicensePlans?.length) {
      const maxBaseLicensePlanNames = _.chain(maxBaseLicensePlans)
        .map((p) => translation(p.typeNameKey))
        .filter(Boolean)
        .join(',')
        .value();

      MessageBox.alert(translation('billing.licences_limit_tips',
        [maxBaseLicensePlanNames, translation('billing.zone_pro_plus.title')]),
        translation('billing.common.can_not_continue'));

      return Promise.reject();
    }
  }

  return Promise.resolve();
};

export const preCheckZoneProPlusForAdd = () => {
  const getters = store.getters;
  const currentBasePlanType = getters.getCurrentBasePlanInfo.planType;

  // config base plan is zoom one pro plus
  if (isProPlusContext && currentBasePlanType === planTypes.ZONE_PRO_PLUS) {
    const { getSelectedPlans, getUserCurrentSubscriptions = [] } = store.getters;

    // Check if the total number of calling plans and ZPI plans is more than 99
    const pbxCallingPlans = computedCallingPlans(getUserCurrentSubscriptions);
    const pbxAddonPlans = computedPbxAddonPlans(getSelectedPlans);
    const pbxCallingPlansCount = pbxCallingPlans.reduce((total, x) => total + (x.cartInfo.selected_number ?? 0), 0);
    const pbxAddonPlansCount = pbxAddonPlans.reduce((total, x) => total + (x.cartInfo.selected_number ?? 0), 0);

    if (pbxCallingPlansCount + pbxAddonPlansCount > 99) {
      Vue.prototype.$message.error({
        message: translation('billing.scheduler.more_than_99_users', [99, getCommonContactSalesLink()]),
        dangerouslyUseHTMLString: true,
      });
      return Promise.reject();
    }
  }

  return Promise.resolve();
};
